import { render, staticRenderFns } from "./MenuConfig.vue?vue&type=template&id=0114bfce&scoped=true&"
import script from "./MenuConfig.vue?vue&type=script&lang=js&"
export * from "./MenuConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0114bfce",
  null
  
)

export default component.exports